module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sbox"
  }, [_c('h2', {
    staticClass: "subchapter",
    attrs: {
      "id": "s004"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/toc#s4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Cinnamon Roll Casserole")])])]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/10-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "recipe"
  }, [_vm._v("Yield: Serves 8 | Prep Time: 15 minutes | Cook Time: 30 minutes")]), _vm._v(" "), _c('p', {
    staticClass: "recipenote"
  }, [_vm._v("We all know the smell of cinnamon rolls baking, the stickiness that comes with eating a vanilla-glazed sweet bun, and the burst of powdered sugar glaze and warm raisins when we take the first bite. But I’ll bet that most often you bake cinnamon rolls in a single layer on a cookie sheet in the oven. I guarantee this version, layered in a casserole dish and dredged in cinnamon sugar batter, will be the ooey-gooiest in your recipe collection.")])]), _vm._v(" "), _c('p', {
    staticClass: "serves"
  }, [_c('strong', [_vm._v("INGREDIENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "rhead"
  }, [_c('strong', [_vm._v("Casserole")])]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("2 (12-ounce) tubes cinnamon rolls")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("¼ cup light brown sugar")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("1½ cups raisins")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("4 large eggs")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("½ cup heavy cream")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("2 tablespoons maple syrup")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("2 teaspoons vanilla extract")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("1 teaspoon ground cinnamon")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("¼ teaspoon ground nutmeg")]), _vm._v(" "), _c('p', {
    staticClass: "rhead"
  }, [_c('strong', [_vm._v("Cream Cheese Icing")])]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("4 ounces cream cheese, room temperature")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("1 cup powdered sugar")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("4 tablespoons unsalted butter, room temperature")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("½ teaspoon vanilla extract")]), _vm._v(" "), _c('h2', {
    staticClass: "Directions"
  }, [_c('strong', [_vm._v("DIRECTIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_vm._v("1. Preheat the oven to 350°F and lightly coat a 9-inch pie plate with cooking spray.")]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_vm._v("2. Arrange a layer of the cinnamon rolls to completely cover the bottom of the pie plate. Sprinkle 2 tablespoons of the brown sugar, then ½ cup raisins, over the cinnamon rolls. Whisk together the eggs, cream, maple syrup, vanilla, cinnamon, and nutmeg and pour over the rolls. Place the remaining rolls on top and sprinkle with the remaining brown sugar and ½ cup raisins. Bake for 30 minutes, until the top is golden brown.")]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_vm._v("3. For the cream cheese icing: While the cinnamon rolls are baking, prepare the icing by combining the cream cheese, powdered sugar, butter, and vanilla with a whisk or hand mixer until smooth.")]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_vm._v("4. Drizzle the cream cheese icing over the hot cinnamon rolls and top with the remaining raisins. Serve.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8c1b9572","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/s004.vue
// module id = 93
// module chunks = 0